import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Container,
  Stack,
  Card,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';

import { getGlobalContractParams } from 'services/requests/globalContractParams';
import { toast } from 'utils';

import GlobalContractParamsForm from 'sections/settings/GlobalContractParamsForm';

export default function GlobalContractParams() {
  const [loading, setLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  const getData = () => {
    setLoading(true);
    getGlobalContractParams()
      .then((res) => {
        setDefaultValues(res);
      })
      .catch((err) => {
        toast(err, 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSuccess = () => {
    getData();
  };

  return (
    <>
      <Helmet>
        <title>Configurações de Contrato | CredPah</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4">Configurações de Contrato</Typography>
        </Stack>

        <Card sx={{ p: 3 }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
              <CircularProgress />
            </Box>
          ) : (
            <GlobalContractParamsForm
              defaultValues={defaultValues}
              onSuccess={handleSuccess}
            />
          )}
        </Card>
      </Container>
    </>
  );
}

